import { mainApi } from "services/main";
import { CreatePaymentRequest, CreatePaymentResponse } from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createPayment: builder.mutation<
      CreatePaymentResponse,
      CreatePaymentRequest
    >({
      query: (request: CreatePaymentRequest) => ({
        url: "payment",
        body: request,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreatePaymentMutation } = extendedApi;
